import { render } from "./Header.vue?vue&type=template&id=3b1dd7a7&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=3b1dd7a7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b1dd7a7"

export default script